'use strict';

import { ONLINERETURN } from '../constants/ActionTypes';

const initState = {
  RETURN_APPLY: null,
  RETURN_INFO:null,
  RETURN_PAY_INFO:null,
  ORDER_PRD_DETAIL: null
};
export default function(state = initState, action = {}) {
  switch (action.type) {
    case ONLINERETURN.RETURN_APPLY:
      return Object.assign({}, state, {
        RETURN_APPLY: action.params
      });
    case ONLINERETURN.RETURN_INFO:
      return Object.assign({}, state, {
        RETURN_INFO: action.params
      });
    case ONLINERETURN.RETURN_PAY_INFO:
      return Object.assign({}, state, {
        RETURN_PAY_INFO: action.params
      });
    case ONLINERETURN.ORDER_PRD_DETAIL:
      return Object.assign({}, state, {
        ORDER_PRD_DETAIL: action.params
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./common/reducers/onLineReturn.js